import { useEffect, useState } from 'react';

export function useAndroid() {
  const [isAndroid, setIsAndroid] = useState(true);
  useEffect(() => {
    const u = window.navigator.userAgent;
    const isIOS = /Macintosh|Mac OS X/i.test(u) || /iPhone|iPad|iPod/i.test(navigator.userAgent); // ios终端
    if (isIOS) setIsAndroid(false);
  }, []);
  return isAndroid;
}

export const useCountDown = ({ endTime, onEnd }: {endTime: number, onEnd?: VoidFunction}): {second: string, minute: string, hour: string} => {
  const [end, setEnd] = useState(false);
  const calculateTimeLeft = () => {
    const difference = Math.max(new Date(endTime).valueOf() - new Date().valueOf(), 0);
    const hour = Math.floor((difference / (1000 * 60 * 60)));
    const minute = Math.floor((difference / 1000 / 60) % 60);
    const second = Math.floor((difference / 1000) % 60);
    const timeLeft = {
      hour: hour < 10 ? `0${hour}` : `${hour}`,
      minute: minute < 10 ? (`0${minute}`) : `${minute}`,
      second: second < 10 ? `0${second}` : `${second}`,
    };

    return timeLeft;
  };
};

/* 判断是否为移动端 */
export function useMobile() {
  const [isMobile, setMobile] = useState<boolean>(false);
  if (typeof window === 'undefined') {
    return [isMobile];
  }
  useEffect(() => {
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) && window.matchMedia('only screen and (max-width:767px)').matches) {
      setMobile(true);
    } else {
      (
        setMobile(false)
      );
    }
  }, [window.navigator.userAgent]);
  return [isMobile];
}
